import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./PreFlashTower.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import PreFlashLaboratory from "./PreFlashLaboratory";

import VaporLiquidGrid from "../components/VaporLiquidGrid";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function PreFlashTower() {

    useEffect(() => {
    
      trackPageVisit("PreFlashTower");
    
    }, []);
  
     const {toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
  const [showPreFlashLab, setShowPreFlashLab] = useState(false);






  const DEFAULT_VALVES = {
  FCV_16001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_16002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_16003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_16004: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("PreFlashTower_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_16001: { ...DEFAULT_VALVES.FCV_16001, ...parsed.FCV_16001 },
      FCV_16002: { ...DEFAULT_VALVES.FCV_16002, ...parsed.FCV_16002 },
      FCV_16003: { ...DEFAULT_VALVES.FCV_16003, ...parsed.FCV_16003 },
      FCV_16004: { ...DEFAULT_VALVES.FCV_16004, ...parsed.FCV_16004 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PreFlashTower_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };



    
const refineryFeed = JSON.parse(
    localStorage.getItem("ACTIVE_BLEND")
) || {};






// =========================================================
// REFINERY FEED FROM DAY TANK V-1502
// =========================================================

const blended =
  refineryFeed.properties || {};

const feedCrudes =
  refineryFeed.feedCrudes || {};

const blendInfo =
refineryFeed.blendInfo || {};


const flowInfo =
refineryFeed.flowInfo || {};


const properties =
refineryFeed.properties || {};



/* =========================================================
   SAFE NUMBER PARSER
========================================================= */

const getNumber = (value) => {

  if (value === undefined || value === null)
    return 0;

  if (typeof value === "number")
    return value;

  if (typeof value === "string") {

    return (
      parseFloat(
        value.replace(/[^\d.-]/g, "")
      ) || 0
    );

  }

  if (typeof value === "object") {

    if (value.value !== undefined)
      return getNumber(value.value);

    if (value.valueMin !== undefined)
      return getNumber(value.valueMin);

    if (value.valueMax !== undefined)
      return getNumber(value.valueMax);

  }

  return 0;

};


/* =========================================================
   TBP DISTILLATION
========================================================= */

const IBP   = getNumber(blended?.tbpDistillation?.[70]);
const TBP5  = getNumber(blended?.tbpDistillation?.[71]);
const TBP10 = getNumber(blended?.tbpDistillation?.[72]);
const TBP20 = getNumber(blended?.tbpDistillation?.[73]);
const TBP30 = getNumber(blended?.tbpDistillation?.[74]);
const TBP40 = getNumber(blended?.tbpDistillation?.[75]);
const TBP50 = getNumber(blended?.tbpDistillation?.[76]);
const TBP60 = getNumber(blended?.tbpDistillation?.[77]);
const TBP70 = getNumber(blended?.tbpDistillation?.[78]);
const TBP80 = getNumber(blended?.tbpDistillation?.[79]);
const TBP90 = getNumber(blended?.tbpDistillation?.[80]);
const TBP95 = getNumber(blended?.tbpDistillation?.[81]);
const FBP   = getNumber(blended?.tbpDistillation?.[82]);


/* =========================================================
   PRODUCT YIELDS
========================================================= */

console.log("CUT YIELDS", blended.cutYields);
console.log(
  "RAW WT",
  blended?.cutYields?.LightNaphtha?.wt
);



const lightNaphthaYield =
  getNumber(blended?.cutYields?.LightNaphtha?.wt);

const heavyNaphthaYield =
  getNumber(blended?.cutYields?.HeavyNaphtha?.wt);

const keroseneYield =
  getNumber(blended?.cutYields?.Kerosene?.wt);

const dieselYield =
  getNumber(blended?.cutYields?.Diesel?.wt);

const vgoYield =
  getNumber(blended?.cutYields?.VGO?.wt);

const residueYield =
  getNumber(blended?.cutYields?.Residue?.wt);


/* =========================================================
   FEED PROPERTIES
========================================================= */

const crudeName =
  refineryFeed?.blendInfo?.blendName ||
  "Unknown Blend";

const crudeType =
  refineryFeed?.blendInfo?.blendGrade ||
  "Unknown";

const crudeAPI =
  getNumber(
    blended?.physicalProperties?.[7]
  );

const crudeDensity =
  getNumber(
    blended?.physicalProperties?.[9]
  );


/* =========================================================
   DEBUG
========================================================= */

console.log("Refinery Feed", refineryFeed);
console.log("Blend", blended);
console.log("Blend Name", crudeName);
console.log("Blend Grade", crudeType);
console.log("API", crudeAPI);
console.log("Density", crudeDensity);
console.log("IBP", IBP);
console.log("TBP10", TBP10);
console.log("Light Naphtha", lightNaphthaYield);
console.log("Heavy Naphtha", heavyNaphthaYield);


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
   const { transmitters, flowOverrides} = usePlantStore();
    const TT_15009 = transmitters.TT_15009 || 0;
    const FIC_13011 = transmitters.FIC_13011 || 0;
    const FIC_13006 = transmitters.FIC_13006 || 0;
    const FIC_12006 = transmitters.FIC_12006 || 0;
    const PT_1901 = transmitters.PT_1901 || 0;
    const FIC_18005 = transmitters.FIC_18005 || 0;
    const FIC_18009 = transmitters.FIC_18009 || 0;
    const FCV_2101 = transmitters.FCV_2101 || 0;
    const FCV_2102 = transmitters.FCV_2102 || 0;
    const TT_18002 = transmitters.TT_18002 || 0;
    const FIC_3105 = transmitters.FIC_3105 || 0;



    const BackPressureFactor =
        Number(
          localStorage.getItem(
            "BackPressureFactor"
          )
        ) || 0;
  


    const xv16001Open = !valves?.XV_16001;
    const xv16003Open = !valves?.XV_16003;
    const xv16004Open = !valves?.XV_16004;
    const xv16005Open = !valves?.XV_16005;
    const xv16006Open = !valves?.XV_16006;



    const NaphthaRefluxFCV = (valveData?.FCV_16004?.opening || 0)/100;



    const TT_16001 = TT_15009;
    const FIC_16001 = FIC_13011*0.9879;
    const FIC_16002 = FIC_13006 + FIC_12006;
    const FIC_16004 = FIC_18005;
    const FIC_16003 = FIC_16001 + FIC_16002;


  
  // ================= CHEMICAL INJECTIONS =================
        const FIC_16006 = FIC_18009;    // ================= WATER INJECTION 
        const FIC_16007 = xv16003Open ? FIC_3105/159 : 0;    // ================= CORROSION INHIBITOR INJECTION 
        const FIC_16008 = xv16004Open ? 0.1829 : 0;    // ================= AMINE INHIBITOR INJECTION 


      const TT_16006 = TT_18002;  // ================= REFLUX TEMPERATURE







/* =========================================================
   PRE-FLASH TOWER SEPARATION MODEL
========================================================= */

/* ---------------------------------------------------------
   FEEDS
--------------------------------------------------------- */

console.log("FIC_16001 =", FIC_16001);
console.log("FIC_16002 =", FIC_16002);
console.log("FIC_16006 =", FIC_16006);
console.log("FIC_16007 =", FIC_16007);
console.log("FIC_16008 =", FIC_16008);

const CrudeFeed =
  FIC_16001 +
  FIC_16002;

const NonHydrocarbonFeed =
  FIC_16006 +
  FIC_16007 +
  FIC_16008;

const TotalFeed =
  CrudeFeed +
  NonHydrocarbonFeed;

/* ---------------------------------------------------------
   REFLUX RATIO
--------------------------------------------------------- */

const refluxRatio =
  CrudeFeed > 0
    ? FIC_16004 / CrudeFeed
    : 0;

/* ---------------------------------------------------------
   WATER / STRIPPING EFFECT
--------------------------------------------------------- */

const waterRatio =
  CrudeFeed > 0
    ? FIC_16006 / CrudeFeed
    : 0;

/*
Steam / water injection assists
light-end stripping
*/

const steamBoost =
  1 +
  (
    waterRatio * 0.15
  );

/* ---------------------------------------------------------
   TBP-BASED VAPORIZATION
--------------------------------------------------------- */

let vaporFraction = 0;

/*
TT_16001 =
Crude temperature leaving
heat exchanger train and
entering Pre-Flash Tower
*/

if (TT_16001 < IBP)
{
  vaporFraction = 0.02;
}
else if (TT_16001 < TBP5)
{
  vaporFraction = 0.04;
}
else if (TT_16001 < TBP10)
{
  vaporFraction = 0.07;
}
else if (TT_16001 < TBP20)
{
  vaporFraction = 0.10;
}
else if (TT_16001 < TBP30)
{
  vaporFraction = 0.13;
}
else
{
  vaporFraction = 0.16;
}

/* ---------------------------------------------------------
   WATER STRIPPING ASSIST
--------------------------------------------------------- */

vaporFraction =
  vaporFraction *
  steamBoost;

/* ---------------------------------------------------------
   REFLUX FLOW EFFECT
--------------------------------------------------------- */

/*
Higher reflux flow causes
more condensation and
reduces overhead vapor
*/

const refluxCorrection =
  Math.max(
    0.40,
    1 -
    (
      refluxRatio * 0.75
    )
  );

/* ---------------------------------------------------------
   REFLUX TEMPERATURE EFFECT
--------------------------------------------------------- */

/*
TT_16006 =
Reflux temperature from
V-101 reflux drum

Cold reflux:
More condensation

Warm reflux:
Less condensation
*/

const refluxTemperatureFactor =
  Math.max(
    0.75,
    Math.min(
      1.25,
      1 +
      (
        (TT_16006 - 60)
        * 0.005
      )
    )
  );

/* ---------------------------------------------------------
   APPLY REFLUX EFFECTS
--------------------------------------------------------- */

vaporFraction =
  vaporFraction *
  refluxCorrection *
  refluxTemperatureFactor;



  /* ==========================================
   VAPOR GENERATION
========================================== */

const VaporGeneration =
  CrudeFeed *
  vaporFraction;

  /* ==========================================
   VAPOR PRESSURE EFFECT
========================================== */

const VaporPressureEffect =
  VaporGeneration * 0.02;

const RefluxCooling = FIC_16004 * 2.5;
/* ---------------------------------------------------------
   FINAL LIMITS
--------------------------------------------------------- */

vaporFraction =
  Math.max(
    0.02,
    Math.min(
      0.25,
      vaporFraction
    )
  );

/* ---------------------------------------------------------
   OVERHEAD VAPOR
--------------------------------------------------------- */

const HydrocarbonVapor =
  CrudeFeed *
  vaporFraction;

const FIC_16009 =
  HydrocarbonVapor;

/* ---------------------------------------------------------
   BOTTOMS PRODUCT
--------------------------------------------------------- */

const FIC_16013 =
  TotalFeed -
  FIC_16009;

/* =========================================================
   PREFLASH COMPONENT SPLIT
========================================================= */

const TotalLightNaphtha =
  lightNaphthaYield || 0;

const TotalHeavyNaphtha =
  heavyNaphthaYield || 0;

const TotalKerosene =
  keroseneYield || 0;

const TotalDiesel =
  dieselYield || 0;

const TotalVGO =
  vgoYield || 0;

const TotalResidue =
  residueYield || 0;

/* ---------------------------------------------------------
   COMPONENT REMOVALS
--------------------------------------------------------- */

/*
Light Naphtha is the
primary target of the
Pre-Flash Tower
*/

const LightNaphthaRemoval =
  Math.min(
    0.95,
    vaporFraction * 4
  );

/*
Heavy Naphtha partially
flashes overhead
*/

const HeavyNaphthaRemoval =
  Math.min(
    0.40,
    vaporFraction * 1.5
  );

/*
Small kerosene entrainment
*/

const KeroseneRemoval =
  Math.min(
    0.10,
    vaporFraction * 0.30
  );

/*
Negligible flashing
*/

const DieselRemoval = 0;
const VGORemoval = 0;
const ResidueRemoval = 0;

/* =========================================================
   OVERHEAD COMPOSITION
========================================================= */

console.log("Reached Composition Section");

const OverheadComposition = {

  LightNaphtha:
    TotalLightNaphtha *
    LightNaphthaRemoval,

  HeavyNaphtha:
    TotalHeavyNaphtha *
    HeavyNaphthaRemoval,

  Kerosene:
    TotalKerosene *
    KeroseneRemoval,

  Diesel:
    TotalDiesel *
    DieselRemoval,

  VGO:
    TotalVGO *
    VGORemoval,

  Residue:
    TotalResidue *
    ResidueRemoval

};

console.log("OverheadComposition =", OverheadComposition);

/* =========================================================
   BOTTOMS COMPOSITION
========================================================= */

const BottomsComposition = {

  LightNaphtha:
    TotalLightNaphtha -
    OverheadComposition.LightNaphtha,

  HeavyNaphtha:
    TotalHeavyNaphtha -
    OverheadComposition.HeavyNaphtha,

  Kerosene:
    TotalKerosene -
    OverheadComposition.Kerosene,

  Diesel:
    TotalDiesel -
    OverheadComposition.Diesel,

  VGO:
    TotalVGO -
    OverheadComposition.VGO,

  Residue:
    TotalResidue -
    OverheadComposition.Residue

};

/* =========================================================
   SAVE OVERHEAD STREAM
========================================================= */

localStorage.setItem(
  "PreFlashOverheadComposition",
  JSON.stringify(
    OverheadComposition
  )
);

localStorage.setItem(
  "PreFlashOverheadFlow",
  FIC_16009
);


console.log(
    "Read Back Overhead:",
    JSON.parse(
        localStorage.getItem("PreFlashOverheadComposition")
    )
);




/* =========================================================
   BOTTOMS COMPONENT FLOWRATES
========================================================= */

const BottomsFlowComposition = {

  LightNaphtha:
    FIC_16013 *
    (BottomsComposition.LightNaphtha || 0) /
    100,

  HeavyNaphtha:
    FIC_16013 *
    (BottomsComposition.HeavyNaphtha || 0) /
    100,

  Kerosene:
    FIC_16013 *
    (BottomsComposition.Kerosene || 0) /
    100,

  Diesel:
    FIC_16013 *
    (BottomsComposition.Diesel || 0) /
    100,

  VGO:
    FIC_16013 *
    (BottomsComposition.VGO || 0) /
    100,

  Residue:
    FIC_16013 *
    (BottomsComposition.Residue || 0) /
    100

};


console.log("BottomsFlowComposition =", BottomsFlowComposition);

console.log("Writing PreFlashBottomsFlowComposition");

localStorage.setItem(
  "PreFlashBottomsFlowComposition",
  JSON.stringify(
    BottomsFlowComposition
  )
);


console.log(
    "Read Back:",
    JSON.parse(
        localStorage.getItem("PreFlashBottomsFlowComposition")
    )
);


/* =========================================================
   SAVE BOTTOMS STREAM
========================================================= */

localStorage.setItem(
  "PreFlashBottomsComposition",
  JSON.stringify(
    BottomsComposition
  )
);

localStorage.setItem(
  "PreFlashBottomsFlow",
  FIC_16013
);





    const PT_16001 = PT_1901 * 0.314;
    const PT_16002 = (PT_16001 * 0.60) + VaporPressureEffect + BackPressureFactor - (refluxRatio * 0.05);
    const PT_16003 = (PT_16001 * 0.80) + (VaporPressureEffect * 1.3) + (BackPressureFactor * 1.1) - (refluxRatio * 0.03);
    const PT_16004 = (PT_16001 * 1.00) + (VaporPressureEffect * 1.6) + (BackPressureFactor * 1.2);

    /* ==========================================
   PREFLASH TOWER TEMPERATURE PROFILE
========================================== */

/* TOP TEMPERATURE */

const TT_16002 =
Math.max(
  40,

  Math.min(

    (
      TT_16001 * 0.72
    )
    +
    (
      VaporGeneration * 0.35
    )
    +
    (
      PT_16002 * 1.5
    )
    -
    RefluxCooling,

    TT_16001 - 15
  )
);


/* MIDDLE TEMPERATURE */

const TT_16003 =
Math.max(

  TT_16002 + 5,

  Math.min(

    (
      TT_16001 * 0.85
    )
    +
    (
      VaporGeneration * 0.20
    )
    +
    (
      PT_16003 * 1.8
    )
    -
    (
      RefluxCooling * 0.50
    ),

    TT_16001 - 5
  )
);



/* BOTTOM TEMPERATURE */

const TT_16004 =
Math.max(

  TT_16003 + 5,

  (
    TT_16001 * 0.96
  )
  +
  (
    VaporGeneration * 0.10
  )
  +
  (
    PT_16004 * 2.2
  )

);


    const P101_ControlValve = (valveData?.FCV_16001?.opening || 0)/100; 








/* =========================================================
 PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};

    
    

/* =========================================================
   P-103A / B STATUS
========================================================= */

const P103A_Running =
  pumpData?.["P-103A"]?.running ?? false;

const P103B_Running =
  pumpData?.["P-103B"]?.running ?? false;

const P103_Running =
  P103A_Running || P103B_Running;


/* =========================================================
   SUCTION VALVE CHECK
========================================================= */

const suctionAvailable =
  xv16006Open === true;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P103_CAPACITY = 35.546;


/* =========================================================
   CONTROL VALVE OPENINGS
========================================================= */

const FCV16002_Opening = FCV_2101;

const FCV16003_Opening = FCV_2102;


/* =========================================================
   TOTAL VALVE OPENING
========================================================= */

const totalOpening =
  FCV16002_Opening +
  FCV16003_Opening;


/* =========================================================
   PUMP UTILIZATION
========================================================= */

const PumpUtilization =
  Math.min(totalOpening, 1);


/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow =
  (P103_Running && suctionAvailable)
    ? P103_CAPACITY * PumpUtilization
    : 0;


/* =========================================================
   TARGET DISCHARGE FLOWS
========================================================= */

const targetFIC_16010 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV16002_Opening / totalOpening)
    : 0;


const targetFIC_16011 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV16003_Opening / totalOpening)
    : 0;


/* /* =========================================================
   FIC-16010
========================================================= */

const FIC_16010 = processData.FIC_16010 || 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_16010_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_16010 || 0);

    let next = current;

    const systemActive =
      P103A_Running ||
      P103B_Running;

    const target =
      systemActive
        ? targetFIC_16010
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_16010: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_16010,
  P103A_Running,
  P103B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_16010_LastUpdate",
    String(Date.now())
  );

}, [FIC_16010]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_16010 || 0);

      const target =
        Number(targetFIC_16010 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_16010: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_16010]);

/* =========================================================
   FIC-16011
========================================================= */

const FIC_16011 =  processData.FIC_16011 || 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_16011_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_16011 || 0);

    let next = current;

    const systemActive =
      P103A_Running ||
      P103B_Running;

    const target =
      systemActive
        ? targetFIC_16011
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_16011: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_16011,
  P103A_Running,
  P103B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_16011_LastUpdate",
    String(Date.now())
  );

}, [FIC_16011]);



useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_16011 || 0);

      const target =
        Number(targetFIC_16011 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_16011: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_16011]);

/* =========================================================
   TOTAL DISCHARGE FLOW
========================================================= */

const FIC_16005 = flowOverrides?.FIC_16005 ? 0 :
  (Number(
    (
      FIC_16010 +
      FIC_16011
    ).toFixed(3)
  ));

useEffect(() => {

  setProcessData(prev => {

    if (prev.FIC_16005 === FIC_16005) {
      return prev;
    }

    return {
      ...prev,
      FIC_16005
    };

  });

}, [FIC_16005]);

/* =========================================================
   DISCHARGE PRESSURE PT-16005
========================================================= */

let targetPT_16005 = 0.03;


if (
  P103_Running &&
  suctionAvailable &&
  totalOpening > 0
) {

  /*
   Higher resistance
   = higher pressure.
  */

  targetPT_16005 =
    0.03 +
    (
      1.764 - 0.03
    ) *
    (
      1 -
      PumpUtilization
    );

}


const PT_16005 =
  Number(
    targetPT_16005.toFixed(3)
  );


/* =========================================================
   DISCHARGE TEMPERATURE TT-16005
========================================================= */

let targetTT_16005 = 25;


if (
  P103_Running &&
  suctionAvailable
) {

  targetTT_16005 =
    Number(TT_16004 || 25);

  /*
   Slight temperature rise
   during restriction.
  */

  if (
    totalOpening > 0 &&
    totalOpening < 0.35
  ) {

    const restrictionFactor =
      (0.35 - totalOpening) /
      0.35;

    targetTT_16005 =
      Number(TT_16004 || 25) +
      restrictionFactor * 2;

  }

}


const TT_16005 =
  Number(
    targetTT_16005.toFixed(2)
  );



localStorage.setItem(
"PREFLASH_OPERATION",
JSON.stringify({
TotalFeed,
NonHydrocarbonFeed,
refluxRatio,
waterRatio,
steamBoost,
vaporFraction,
VaporGeneration,
RefluxCooling
})
);




useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_16002 === TT_16002 &&
    current.PT_16002 === PT_16002 &&
    current.PT_16005 === PT_16005 &&
    current.FIC_16005 === FIC_16005 &&
    current.FIC_16009 === FIC_16009 &&
    current.FIC_16010 === FIC_16010 &&
    current.FIC_16011 === FIC_16011 &&
    current.TT_16005 === TT_16005 &&
    current.FIC_16004 === FIC_16004 &&
    current.FCV_2101 === FCV_2101 &&
    current.FCV_2102 === FCV_2102 &&
    current.NaphthaRefluxFCV === NaphthaRefluxFCV &&
    current.P101_ControlValve === P101_ControlValve 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_16002, PT_16002, PT_16005, FIC_16005, FIC_16004, FIC_16009, FIC_16010, FIC_16011, TT_16005, FCV_2101, FCV_2102, NaphthaRefluxFCV, P101_ControlValve,
    }
  });

}, [TT_16002, PT_16002, PT_16005, FIC_16005, FIC_16009, FIC_16004, FIC_16010, FIC_16011, TT_16005, FCV_2101, FCV_2102, NaphthaRefluxFCV, P101_ControlValve]);




/* =========================================================
   PREFLASH LABORATORY REPORT
========================================================= */

useEffect(() => {

    /* =========================================================
   PREFLASH LABORATORY REPORT STORAGE
========================================================= */


const preFlashReport = {


generated:
new Date().toLocaleString(),


reportNumber:

"PF-" +
Date.now(),



refineryFeed: refineryFeed,



feed:

{


flow:
CrudeFeed,


temperature:
TT_16001,


pressure:
PT_16001,


density:
blended?.physicalProperties?.[9],


sulfur:
blended?.bulkElementalComposition?.[3],


TAN:
blended?.corrosionStability?.[24]

},




operation:

{


CrudeFeed,

NonHydrocarbonFeed,

TotalFeed,


refluxRatio,


waterRatio,


steamBoost,


vaporFraction,


VaporGeneration,


RefluxCooling


},




tower:

{

top:

{
temperature:
TT_16002,

pressure:
PT_16002
},


middle:

{
temperature:
TT_16003,

pressure:
PT_16003
},


bottom:

{
temperature:
TT_16004,

pressure:
PT_16004
}


},




overhead:

{


flow:
FIC_16009,


composition:
OverheadComposition


},




bottoms:

{


flow:
FIC_16013,


composition:
BottomsComposition,


flowComposition:
BottomsFlowComposition


},




performance:

{


vaporRecovery:
vaporFraction * 100,


liquidRecovery:
(1-vaporFraction)*100,


materialBalance:

TotalFeed > 0

?

(
(
FIC_16009+
FIC_16013
)
/TotalFeed
)*100

:

100


}



};


localStorage.setItem(

"PREFLASH_REPORT",

JSON.stringify(preFlashReport)

);



console.log("Saving PREFLASH_REPORT");
console.log(preFlashReport);


}, [

    CrudeFeed,

    NonHydrocarbonFeed,

    TotalFeed,

    TT_16001,

    PT_16001,

    refluxRatio,

    waterRatio,

    steamBoost,

    vaporFraction,

    VaporGeneration,

    TT_16002,

    TT_16003,

    TT_16004,

    PT_16002,

    PT_16003,

    PT_16004,

    FIC_16009,

    FIC_16013

]);




console.log("Blend", blended);
console.log("Blend Name", crudeName);
console.log("API", crudeAPI);
console.log("Density", crudeDensity);
console.log("IBP", IBP);

console.log("lightNaphthaYield =", lightNaphthaYield);
console.log("heavyNaphthaYield =", heavyNaphthaYield);
console.log("keroseneYield =", keroseneYield);
console.log("dieselYield =", dieselYield);
console.log("vgoYield =", vgoYield);
console.log("residueYield =", residueYield);




const PreFlashBottomStream = {

    streamName: "PreFlash Bottoms",

    flow: FIC_16013,

    temperature: TT_16004,

    pressure: PT_16004,

    composition: BottomsComposition,

    flowComposition: BottomsFlowComposition,

    properties: {

        API: crudeAPI,

        density: crudeDensity,

        sulfur: getNumber(
            blended?.bulkElementalComposition?.[3]
        ),

        TAN: getNumber(
            blended?.corrosionStability?.[24]
        ),

        viscosity:
            getNumber(
                blended?.transportProperties?.kinematicViscosity40
            ),

        CCR:
            getNumber(
                blended?.residueProperties?.CCR
            ),

        asphaltenes:
            getNumber(
                blended?.hydrocarbonAnalysis?.Asphaltenes
            ),

        pourPoint:
            getNumber(
                blended?.transportProperties?.pourPoint
            ),

        molecularWeight:
            getNumber(
                blended?.hydrocarbonAnalysis?.AverageMolecularWeight
            )

    }

};

localStorage.setItem(
    "PREFLASH_BOTTOM",
    JSON.stringify(PreFlashBottomStream)
);


  return (
    <div className="PreFlashTower-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 303px",
          zIndex: 10,
        }}
      >
        PRE-FLASH TOWER
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}



      {/* XV-16003 */}
      <Valve
        className="XV-16003"
        tag="XV_16003"
        x={228}
        y={123}
        isClosed={valves.XV_16003}
        toggle={toggleValve}
      />

      {/* XV-16004 */}
      <Valve
        className="XV-16004"
        tag="XV_16004"
        x={228}
        y={173}
        isClosed={valves.XV_16004}
        toggle={toggleValve}
      />

      {/* XV-16005 */}
      <Valve
        className="XV-16005"
        tag="XV_16005"
        x={288}
        y={289}
        isClosed={valves.XV_16005}
        toggle={toggleValve}
      />

      {/* XV-16006 */}
      <Valve
        className="XV-16006"
        tag="XV_16006"
        x={635}
        y={657}
        isClosed={valves.XV_16006}
        toggle={toggleValve}
        r={90}
      />



          {/* ================= VAPOR - LIQUID INTERACTION ================= */}
    
          <VaporLiquidGrid
          x={612}
          y={190}
          width={60}
          height={280}
        />



        <button
          onClick={() => setShowPreFlashLab(true)}
          style={{
              position: "absolute",
              right: "20px",
              top: "350px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 9999
          }}
      >
          🧪 Pre-Flash Laboratory
      </button>


      {showPreFlashLab && (
          <PreFlashLaboratory
              onClose={() => setShowPreFlashLab(false)}
          />
      )}




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-16001 */}
        <div
            style={{ position: "absolute", left: 310, top: 459}}
            onMouseEnter={() => setHoveredValve("FCV_16001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_16001")}
          >

            {hoveredValve === "FCV_16001" && (
              <div style={tagStyle}>
                FCV_16001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-16001">
                    
          <defs>
            <linearGradient id="metal_16001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_16001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_16001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-16004 */}
        <div
            style={{ position: "absolute", left: 1040, top: 182}}
            onMouseEnter={() => setHoveredValve("FCV_16004")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_16004")}
          >

            {hoveredValve === "FCV_16004" && (
              <div style={tagStyle}>
                FCV_16004
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-16004">
                    
          <defs>
            <linearGradient id="metal_16004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_16004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_16004)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



 {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_16001?.opening || 0)}
        x={330}
        y={504}
      />

      <ValveOutput
        value={Number(valveData?.FCV_16004?.opening || 0)}
        x={1060}
        y={228}
      />



        <Transmitter
          tag="TT_16001"
          value={[TT_16001]}
          x={172}
          y={499}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-109A/B TO T-101 INLET"
         />

        <Transmitter
          tag="PT_16001"
          value={[PT_16001]}
          x={172}
          y={412}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE FROM E-109A/B TO T-101 INLET"
         />

        <Transmitter
          tag="PT_16002"
          value={[PT_16002]}
          x={672}
          y={62}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF OVERHEAD VAPOR AT THE TOP OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="PT_16003"
          value={[PT_16003]}
          x={692}
          y={362}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE AT THE FLASH ZONE (MIDDLE) OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="PT_16004"
          value={[PT_16004]}
          x={502}
          y={532}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF FLASHED CRUDE AT THE BOTTOM OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="TT_16002"
          value={[TT_16002]}
          x={832}
          y={62}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF OVERHEAD VAPOR AT THE TOP OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="TT_16003"
          value={[TT_16003]}
          x={692}
          y={312}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE AT THE FLASH ZONE (MIDDLE) OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="TT_16004"
          value={[TT_16004]}
          x={502}
          y={572}
          unit="°C"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF FLASHED CRUDE AT THE BOTTOM OF PREFLASH FRACTIONATION TOWER (T-101)"
         />

        <Transmitter
          tag="FIC_16001"
          value={[FIC_16001]}
          x={172}
          y={449}
          unit="BPM"
          max={300}
          HH={286}
          H={265}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM E-109A/B TO T-101 INLET"
         />

        <Transmitter
          tag="FIC_16002"
          value={[FIC_16002]}
          x={172}
          y={273}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE OIL RETURN FROM V-201A/B TO T-101 INLET"
         />

        <Transmitter
          tag="FIC_16003"
          value={[FIC_16003]}
          x={472}
          y={449}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TO FLASH ZONE OF THE PRE-FLASH TOWER (T-101)"
         />

        <Transmitter
          tag="FIC_16004"
          value={[FIC_16004]}
          x={902}
          y={179}
          unit="BPM"
          max={2}
          HH={1.8}
          H={1.1}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHATHA REFLUX FROM V-101 TO PRE-FLASH TOWER (T-101) OVERHEAD"
         />

         <Transmitter
          tag="FIC_16006"
          value={[FIC_16006]}
          x={172}
          y={64}
          unit="BPM"
          max={2}
          HH={1.5}
          H={0.7}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF WATER INJECTION AT THE OVERHEAD OF PREFLASH TOWER"
         />

         <Transmitter
          tag="FIC_16007"
          value={[FIC_16007]}
          x={142}
          y={114}
          unit="BPM"
          max={2}
          HH={1.5}
          H={0.7}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR INJECTION AT THE OVERHEAD OF PREFLASH TOWER"
         />

         <Transmitter
          tag="FIC_16008"
          value={[FIC_16008]}
          x={142}
          y={164}
          unit="BPM"
          max={2}
          HH={1.5}
          H={0.7}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF AMINE INHIBITOR INJECTION AT THE OVERHEAD OF PREFLASH TOWER"
         />

         <Transmitter
          tag="FIC_16009"
          value={[FIC_16009]}
          x={942}
          y={62}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF OVERHEAD VAPOR OF PREFLASH TOWER TO A-101A-D"
         />

         
         <Transmitter
          tag="FIC_16005"
          value={[FIC_16005]}
          x={1042}
          y={538}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF FLASHED CRUDE FROM BOTTOM OF PREFLASH TOWER TO FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2"
         />


         <Transmitter
          tag="PT_16005"
          value={[PT_16005]}
          x={852}
          y={762}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF FLASHED CRUDE FROM BOTTOM OF PREFLASH TOWER TO FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2"
         />

        <Transmitter
          tag="TT_16005"
          value={[TT_16005]}
          x={1038}
          y={742}
          unit="°C"
          max={300}
          HH={280}
          H={255}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF FLASHED CRUDE FROM BOTTOM OF PREFLASH TOWER TO FURNACE (F-101) AT THE CONVECTION ZONE 1 & 2"
         />

        <Transmitter
          tag="TT_16006"
          value={[TT_16006]}
          x={788}
          y={180}
          unit="°C"
          max={300}
          HH={280}
          H={255}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NAPHTHA REFLUX FROM REFLUX CONDENSER (V-101) TO PREFLASH TOWER TOP"
         />








    <LevelTransmitterIndicator
      tag="LT_16001"
      totalLevel={500}
      inflows={[FIC_16013]}
      outflows={[FIC_16005]}
      inflowTags={["FIC_16013"]}
      outflowTags={["FIC_16005"]}
      responseFactor={0.05}
      columnX={664}
      columnY={429}
      columnWidth={30}
      columnHeight={164}
      textX={706}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.9}
      service="residue"
    />

    <LevelTransmitterIndicator
      tag="LT_16002"
      totalLevel={500}
      inflows={[FIC_16013*0.999]}
      outflows={[FIC_16005]}
      inflowTags={["FIC_16013"]}
      outflowTags={["FIC_16005"]}
      responseFactor={0.05}
      columnX={594}
      columnY={429}
      columnWidth={103}
      columnHeight={164}
      textX={706}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.5}
      liquidOpacity={0.4}
      service="crude"
    />




            <Pump
              tag="P-103A"
              x={764}
              y={729}
              rpm={1800}
              bladeCount={pumpData?.["P-103A"]?.bladeCount || 3}
              size={pumpData?.["P-103A"]?.size || 43}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-103B"
              x={763}
              y={806}
              rpm={1800}
              bladeCount={pumpData?.["P-103B"]?.bladeCount || 3}
              size={pumpData?.["P-103B"]?.size || 43}
              onClick={openPumpPanel}
            />




    

    </div>
  );
}

export default PreFlashTower;